import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLink, UitkLinkAlign, UitkLinkTypeSize } from 'uitk-react-link';
import { ActivityDestinationViewSearch } from '../../../../common/__generated__/api';
import { useStores } from '../../../../utils/hooks';

export interface AnchoredTextProps {
  anchoredText: ActivityDestinationViewSearch.AnchoredText;
}

export const AnchoredText: React.FC<AnchoredTextProps> = ({ anchoredText }): JSX.Element => {
  const { analytics } = useStores();
  const handleClick = (): void => {
    const { referrerId, linkName } = anchoredText.clickAction?.analytics || {};
    analytics.trackEvent(referrerId, linkName, analytics.omnitureData, null, true);
  };
  const clickAction = anchoredText.clickAction;

  return (
    <UitkLink type={UitkLinkTypeSize.SMALL} iconPos={UitkLinkAlign.RIGHT} onClick={handleClick} inline>
      {clickAction?.anchorTagUrl && (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a
          data-testid="anchored-text--link"
          href={clickAction.anchorTagUrl}
          target={clickAction.opensInNewTab ? '_blank' : '_self'}
        >
          <span className="uitk-type-paragraph-200">{anchoredText.text}</span>
          {anchoredText.icon && (
            <UitkIcon
              id={anchoredText.icon.id}
              name={anchoredText.icon.id}
              size={UitkIconSize.SMALL}
              description={anchoredText.icon.description}
            />
          )}
        </a>
      )}
    </UitkLink>
  );
};
